import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Passenger } from '../../models/passenger';
import { InjectAPI, InjectApp, InjectTranslate } from '../app/app';
import { Alert } from '../widgets/alert';
import { ButtonGroup } from '../widgets/button-group';
import { Field } from '../widgets/field';
import { Loader } from '../widgets/loader';
import { PrimaryButton } from '../widgets/primary-button';
import { SendVoucherStore } from './send-voucher-store';

type InjectedProps = InjectAPI & InjectApp & InjectTranslate;

interface RedeemFormProps {
  readonly passenger: Passenger;
}

@observer
export class RedeemFormC extends React.Component<
  RedeemFormProps & InjectedProps
> {
  private readonly store: SendVoucherStore;

  constructor(props: RedeemFormProps & InjectedProps) {
    super(props);
    this.store = new SendVoucherStore(props.app, props.api, props.passenger);
  }

  public render() {
    const { t } = this.props;
    const voucher = this.props.passenger.voucher;

    if (!voucher) {
      throw new Error('Bug');
    }

    if (this.store.sendError) {
      return (
        <Alert type="error">
          <span
            dangerouslySetInnerHTML={{ __html: t('send.form.error_html') }}
          />
        </Alert>
      );
    }

    if (this.store.emailSent) {
      const emails = voucher.emails;
      return (
        <Alert type="success">
          {t('send.form.success', {
            address: emails[emails.length - 1].toAddress,
          })}
        </Alert>
      );
    }

    return (
      <form
        className="redeem-form"
        onSubmit={this.store.handleClickSendVoucher}
      >
        {this.store.loading && <Loader />}
        <h3>{t('send.form.header')}</h3>
        <div>
          <Field
            label="Email"
            value={this.store.email}
            onChange={this.store.setEmail}
            errors={this.store.lastSendVoucherErrors.to_address}
          />
        </div>
        <ButtonGroup>
          <PrimaryButton
            text={t('send.form.button')}
            disabled={this.store.loading}
          />
        </ButtonGroup>
      </form>
    );
  }
}

export const RedeemForm: React.ComponentClass<RedeemFormProps> = withRouter(
  inject('api', 'app', 't')(RedeemFormC),
);



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/redeem/redeem-form.tsx